var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPicture({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.35 13.713H2.39c-.877 0-1.59-.707-1.59-1.59V3.99c0-.878.713-1.591 1.59-1.591h10.96c.878 0 1.591.713 1.591 1.59v8.132c0 .884-.713 1.59-1.59 1.59zM2.39 3.46c-.692 0-.93.237-.93.93v7.731c0 .693.238.93.93.93h10.96c.693 0 .93-.237.93-.93V3.991c0-.693-.237-.93-.93-.93H2.39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.335 7.35a1.416 1.416 0 010-2.828c.78 0 1.414.633 1.414 1.413S5.115 7.35 4.335 7.35zm0-1.768a.354.354 0 100 .707.354.354 0 000-.707zM1.344 12.992a.531.531 0 01-.375-.906L4.165 8.89a1.242 1.242 0 011.755 0l.854.854L9.4 6.593c.634-.282 1.179-.444 1.744-.446.393-.022.711.157.948.435l2.72 4.106a.53.53 0 11-.807.69l-2.72-4.107c-.046-.056-.103-.053-.135-.063-.03 0-.09.01-.136.064l-3.798 4a.53.53 0 01-.782.035L5.17 10.042c-.09-.09-.164-.09-.254 0L1.72 13.237a.531.531 0 01-.375.154l-.002-.4z"
  })));
}

export default SvgPicture;